import { createFileRoute } from '@tanstack/react-router';
import { useRef } from 'react';
import { emitMessage } from '../engine/api';

export const Route = createFileRoute('/test')({
	component: RouteComponent,
});

function RouteComponent() {
	const inputRef = useRef<HTMLInputElement>(null);

	const submitText = () => {
		const input = inputRef.current;
		if (input) {
			const val = input.value;
			input.value = '';
			emitMessage({ kind: 'text-message', message: val });
		}
	};

	return (
		<div>
			<h1 className="animate-bounce p-4 text-4xl text-red-600">GameBoss</h1>
			<div className="flex w-fit flex-col gap-2">
				<input
					ref={inputRef}
					className="rounded-md border border-gray-300 bg-gray-50 p-1"
					type="text"
					name="msg"
					id="msg"
					onKeyDown={(e) => e.key == 'Enter' && submitText()}
				/>
				<button className="rounded-md bg-theme-600 p-1 text-theme-50" onClick={submitText}>
					Submit text
				</button>
				<button
					className="rounded-md bg-theme-600 p-1 text-theme-50"
					onClick={() => {
						emitMessage({ kind: 'empty-message' });
					}}
				>
					Submit empty
				</button>
			</div>
		</div>
	);
}
